import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import About from "./about/About";
import ProjectList from "./projects/ProjectList";
import Research from "./research/Research";
import Drainer from "./drainer/Drainer";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBook,
  faGraduationCap,
  faRunning,
  faClock,
  faMapMarkerAlt,
  faTachometerAlt,
  faHeart,
  faCalendarAlt,
  faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin, faStrava } from "@fortawesome/free-brands-svg-icons";

library.add(
  faBook,
  faGraduationCap,
  faRunning,
  faClock,
  faMapMarkerAlt,
  faTachometerAlt,
  faHeart,
  faCalendarAlt,
  faSignInAlt,
  faGithub,
  faLinkedin,
  faStrava
);

const navigationLinks = [
  { label: "Home", to: "/" },
  // { label: "Now", to: "/now" },
  { label: "Projects", to: "/projects" },
  { label: "Research", to: "/research" },
];

function AppShell() {
  const location = useLocation();

  return (
    <div className="app-shell">
      <header className="site-header">
        <div className="site-header__inner">
          <Link to="/" className="site-brand" aria-label="Yazan Mash'Al home">
            <span className="site-brand__name">Yazan Mash'Al</span>
            <span className="site-brand__meta">Mathematics, machine learning, research</span>
          </Link>

          <nav className="site-nav" aria-label="Main navigation">
            <ul>
              {navigationLinks.map((link) => {
                const isActive = location.pathname === link.to;

                return (
                  <li key={link.to}>
                    <Link className={isActive ? "is-active" : ""} aria-current={isActive ? "page" : undefined} to={link.to}>
                      {link.label}
                    </Link>
                  </li>
                );
              })}
              <li>
                <a href="/blog/">
                  Writing
                </a>
              </li>
              <li>
                <a href="/cv.pdf" target="_blank" rel="noopener noreferrer">
                  CV
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <a className="skip-link" href="#main-content">Skip to content</a>
      <main id="main-content" className="site-main">
        <Routes>
          <Route path="/" element={<About />} />
          {/* <Route path="/now" element={<Now />} /> */}
          <Route path="/projects" element={<ProjectList />} />
          <Route path="/research" element={<Research />} />
          <Route path="/drainer" element={<Drainer />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
